export default {
  GOP_ASSIGNMENT_MODAL: 'modal/backoffice/GOP_ASSIGNMENT_MODAL',
  AWARD_UNIT_DETAIL: 'modal/backoffice/AWARD_UNIT_DETAIL',
  AWARD_LEADER_DETAIL: 'modal/backoffice/AWARD_LEADER_DETAIL',
  AJ_EVENT_SETTINGS: 'modal/backoffice/AJ_EVENT_SETTINGS',
  ADD_ACTIVITY: 'modal/backoffice/ADD_ACTIVITY',
  RESET_PAYMENT_LINK: 'modal/backoffice/RESET_PAYMENT_LINK',
  EDIT_LEADER_REGISTRATION: 'modal/backoffice/EDIT_LEADER_REGISTRATION',
  ASSESSOR_REGISTRATION_DETAIL: 'modal/backoffice/ASSESSOR_REGISTRATION_DETAIL',
  ASSESSOR_REGISTRATION_EDIT: 'modal/backoffice/ASSESSOR_REGISTRATION_EDIT',
  ASSESSOR_REMOVE_ACTIVITY_MODAL: 'modal/backoffice/ASSESSOR_REMOVE_ACTIVITY_MODAL',
  ASSESSOR_ACTIVITY_CATEGORY_INVITATION_MODAL: 'modal/backoffice/ASSESSOR_ACTIVITY_CATEGORY_INVITATION_MODAL',
  ASSESSOR_RESEND_CONFIRMATION_MODAL: 'modal/backoffice/ASSESSOR_RESEND_CONFIRMATION_MODAL',
  INVITE_NEW_ASSESSOR_MODAL: 'modal/backoffice/INVITE_NEW_ASSESSOR_MODAL',
  INVITE_PARTICIPANTS_MODAL: 'modal/backoffice/INVITE_PARTICIPANTS_MODAL',
  TRANSLATIONS_MANAGER_MODAL: 'modal/backoffice/TRANSLATIONS_MANAGEMENT',
  PARTICIPANT_REGISTRATION_DETAIL: 'modal/backoffice/PARTICIPANT_REGISTRATION_DETAIL'
}
